import React from 'react';
import {Text} from '../components';
import styled from 'styled-components';

const Container = styled.div `
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: auto auto auto auto auto;
    width: 100%;
`;

const Title = styled(Text)`
    color: #b8b6b6;
    grid-column-start: 1;
    grid-column-end: 2;
    text-align: right;
`

const SummaryText = styled(Text)`
    color: #b8b6b6;
    flex: 1;
    text-align: left;
    padding-left: 10px;
    grid-column-start: 2;
    grid-column-end: 3;
    padding: 0 10px 0 10px;
`
const DateTitle = styled(Title)`
    font-weight: bold;
    grid-row-start: 1;
`
const DateSummary = styled(SummaryText)`
    grid-row-start: 1;
`
const FuelTitle = styled(Title)`
    font-weight: bold;
    grid-row-start: 2;
`
const FuelSummary = styled(SummaryText)`
    grid-row-start: 2;
`
const DEFTitle = styled(Title)`
    font-weight: bold;
    grid-row-start: 3;
`
const DEFSummary = styled(SummaryText)`
    grid-row-start: 3;
`
const OdometerTitle = styled(Title)`
    font-weight: bold;
    grid-row-start: 4;
`
const OdometerSummary = styled(SummaryText)`
    grid-row-start: 4;
`
const HoursTitle = styled(Title)`
    font-weight: bold;    
    grid-row-start: 5;
`
const HoursSummary = styled(SummaryText)`
    grid-row-start: 5;
`
const CostTitle = styled(Title)`
    font-weight: bold;    
    grid-row-start: 6;
`
const CostSummary = styled(SummaryText)`
    grid-row-start: 6;
`
const NotesTitle = styled(Title)`
    font-weight: bold;    
    grid-row-start: 7;
`
const NotesSummary = styled(SummaryText)`
    grid-row-start: 7;
`
const LogSummary = ({
    date,
    fuelVolume,
    DEFVolume,
    odometer,
    apparatusHours,
    cost,
    notes
}) => {
    const summaryText = {}

    return (
        <Container>
            <DateTitle>Date:
            </DateTitle>
            <DateSummary style={summaryText}>{date}</DateSummary>
            <FuelTitle>Fuel Volume:
            </FuelTitle>
            <FuelSummary style={summaryText}>{fuelVolume}</FuelSummary>
            <DEFTitle>DEF Volume:
            </DEFTitle>
            <CostTitle>Cost:</CostTitle>
            <CostSummary style={summaryText}>{cost}</CostSummary>
            <DEFSummary style={summaryText}>{DEFVolume}</DEFSummary>
            <OdometerTitle>Odometer:
            </OdometerTitle>
            <OdometerSummary style={summaryText}>{odometer}</OdometerSummary>
            <HoursTitle>Apparatus Hours:
            </HoursTitle>
            <HoursSummary style={summaryText}>{apparatusHours}</HoursSummary>
            <NotesTitle>Notes:
            </NotesTitle>
            <NotesSummary style={summaryText}>{notes}</NotesSummary>
        </Container>
    );
}

export default LogSummary;


// WEBPACK FOOTER //
// ./src/ApparatusFuelConfirmation/LogSummary.js